import { getTableColumns } from 'helpers';

const ParticipationInformationColumns = [
  ['siteCtepId', 'string', 'CTEP ID', 'left', true],
  ['name', 'string', 'Institution Name', 'left', true],
  ['siteStartDate', 'string', 'Start Date', 'center', true],
  ['siteEndDate', 'string', 'End Date', 'center', true],
  ['piName', 'string', 'PI Name', 'left', true],
  ['piCtepId', 'string', 'PI CTEP ID', 'left', true],
  ['piStartDate', 'string', 'PI Start Date', 'center', true]
];


export default getTableColumns(ParticipationInformationColumns);
